function sendEmail(data) {
  const endpoint =
    'https://configurator3d-pixlip-go-api-4d5dd836fde5.herokuapp.com/send-email';

  return fetch(endpoint, {
    method: 'post',
    body: JSON.stringify({
      logolink: data.logolink,
      mail: data.mail,
      lang: 'EN',
      pricetotalnoVat: data.total.toString(),
      pricetotalwithVat: data.total.toString(),
      prename: data.firstName,
      name: data.lastName,
      salutation: data.title,
      street: data.street,
      streetnumber: data.streetNo.toString(),
      city: data.city,
      zipcode: data.zipCode,
      country: data.country,
      phone: data.phone,
      imageConfiguratedBooth: data.canvasImg,
      mailto: data.email,
      type: 'reseller',
      positions: data.products,
    }),
    headers: {
      'x-api-key': '8DLLKDJF080DKJUEQ0Y',
      'Content-Type': 'application/json', // Wichtig für das korrekte Verarbeiten von JSON durch den Server
    },
  });
}

export { sendEmail };
